export default function DynamicAllowanceIcon () {
  return (
    <svg
      width={276}
      height={114}
      className='max-w-full'
      viewBox='0 0 276 114'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_dd_1336_27986)'>
        <rect
          x={4}
          y={15}
          width={84}
          height={94}
          rx={4}
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x={4.5}
          y={15.5}
          width={83}
          height={93}
          rx={3.5}
          stroke='url(#paint0_linear_1336_27986)'
          shapeRendering='crispEdges'
        />
        <g clipPath='url(#clip0_1336_27986)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M34.0002 33.9166C34.2303 33.9166 34.4168 34.1032 34.4168 34.3333V42.6666C34.4168 42.8967 34.2303 43.0833 34.0002 43.0833C33.77 43.0833 33.5835 42.8967 33.5835 42.6666V34.3333C33.5835 34.1032 33.77 33.9166 34.0002 33.9166Z'
            fill='#6E6E6E'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M31.6327 35.7158C31.9843 35.3642 32.4612 35.1666 32.9585 35.1666H36.0835C36.3136 35.1666 36.5002 35.3532 36.5002 35.5833C36.5002 35.8134 36.3136 36 36.0835 36H32.9585C32.6822 36 32.4173 36.1097 32.2219 36.3051C32.0266 36.5004 31.9168 36.7654 31.9168 37.0416C31.9168 37.3179 32.0266 37.5828 32.2219 37.7782C32.4173 37.9735 32.6822 38.0833 32.9585 38.0833H35.0418C35.5391 38.0833 36.016 38.2808 36.3677 38.6325C36.7193 38.9841 36.9168 39.461 36.9168 39.9583C36.9168 40.4556 36.7193 40.9325 36.3677 41.2841C36.016 41.6357 35.5391 41.8333 35.0418 41.8333H31.5002C31.27 41.8333 31.0835 41.6467 31.0835 41.4166C31.0835 41.1865 31.27 41 31.5002 41H35.0418C35.3181 41 35.583 40.8902 35.7784 40.6949C35.9737 40.4995 36.0835 40.2346 36.0835 39.9583C36.0835 39.682 35.9737 39.4171 35.7784 39.2217C35.583 39.0264 35.3181 38.9166 35.0418 38.9166H32.9585C32.4612 38.9166 31.9843 38.7191 31.6327 38.3675C31.281 38.0158 31.0835 37.5389 31.0835 37.0416C31.0835 36.5443 31.281 36.0674 31.6327 35.7158Z'
            fill='#6E6E6E'
          />
        </g>
        <path
          d='M39.5824 40.5085V39.7841L42.7784 34.7273H43.304V35.8494H42.9489L40.5341 39.6705V39.7273H44.8381V40.5085H39.5824ZM43.0057 42V40.2884V39.951V34.7273H43.8438V42H43.0057ZM48.941 42.0994C48.406 42.0994 47.9502 41.9538 47.5738 41.6626C47.1974 41.3691 46.9098 40.9441 46.7109 40.3878C46.512 39.8291 46.4126 39.1544 46.4126 38.3636C46.4126 37.5777 46.512 36.9065 46.7109 36.3501C46.9121 35.7914 47.201 35.3653 47.5774 35.0717C47.9562 34.7758 48.4107 34.6278 48.941 34.6278C49.4713 34.6278 49.9247 34.7758 50.3011 35.0717C50.6799 35.3653 50.9687 35.7914 51.1676 36.3501C51.3688 36.9065 51.4694 37.5777 51.4694 38.3636C51.4694 39.1544 51.37 39.8291 51.1711 40.3878C50.9723 40.9441 50.6846 41.3691 50.3082 41.6626C49.9318 41.9538 49.4761 42.0994 48.941 42.0994ZM48.941 41.3182C49.4713 41.3182 49.8833 41.0625 50.1768 40.5511C50.4704 40.0398 50.6172 39.3106 50.6172 38.3636C50.6172 37.7339 50.5497 37.1977 50.4147 36.755C50.2822 36.3123 50.0904 35.9749 49.8395 35.7429C49.5909 35.5109 49.2914 35.3949 48.941 35.3949C48.4154 35.3949 48.0047 35.6541 47.7088 36.1726C47.4128 36.6887 47.2649 37.419 47.2649 38.3636C47.2649 38.9934 47.3312 39.5284 47.4637 39.9688C47.5963 40.4091 47.7869 40.7441 48.0355 40.9737C48.2864 41.2034 48.5883 41.3182 48.941 41.3182ZM55.591 42.0994C55.056 42.0994 54.6002 41.9538 54.2238 41.6626C53.8474 41.3691 53.5598 40.9441 53.3609 40.3878C53.162 39.8291 53.0626 39.1544 53.0626 38.3636C53.0626 37.5777 53.162 36.9065 53.3609 36.3501C53.5621 35.7914 53.851 35.3653 54.2274 35.0717C54.6062 34.7758 55.0607 34.6278 55.591 34.6278C56.1213 34.6278 56.5747 34.7758 56.9511 35.0717C57.3299 35.3653 57.6187 35.7914 57.8176 36.3501C58.0188 36.9065 58.1194 37.5777 58.1194 38.3636C58.1194 39.1544 58.02 39.8291 57.8211 40.3878C57.6223 40.9441 57.3346 41.3691 56.9582 41.6626C56.5818 41.9538 56.1261 42.0994 55.591 42.0994ZM55.591 41.3182C56.1213 41.3182 56.5333 41.0625 56.8268 40.5511C57.1204 40.0398 57.2672 39.3106 57.2672 38.3636C57.2672 37.7339 57.1997 37.1977 57.0647 36.755C56.9322 36.3123 56.7404 35.9749 56.4895 35.7429C56.2409 35.5109 55.9414 35.3949 55.591 35.3949C55.0654 35.3949 54.6547 35.6541 54.3588 36.1726C54.0628 36.6887 53.9149 37.419 53.9149 38.3636C53.9149 38.9934 53.9812 39.5284 54.1137 39.9688C54.2463 40.4091 54.4369 40.7441 54.6855 40.9737C54.9364 41.2034 55.2383 41.3182 55.591 41.3182Z'
          fill='#6E6E6E'
        />
        <rect x={16} y={55} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={16} y={71} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={16} y={87} width={60} height={10} rx={2} fill='#E5E5E5' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M46 11C44.8954 11 44 11.8954 44 13C44 14.1046 44.8954 15 46 15C47.1046 15 48 14.1046 48 13C48 11.8954 47.1046 11 46 11ZM42 13C42 10.7909 43.7909 9 46 9C48.2091 9 50 10.7909 50 13C50 15.2091 48.2091 17 46 17C43.7909 17 42 15.2091 42 13Z'
          fill='#6E6E6E'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M46 6C41.0294 6 37 10.0294 37 15C37 17.6718 38.1642 20.0717 40.0131 21.72C40.078 21.0271 40.3825 20.3749 40.8787 19.8787C41.4413 19.3161 42.2043 19 43 19H49C49.7957 19 50.5587 19.3161 51.1213 19.8787C51.6175 20.3749 51.922 21.0271 51.9869 21.72C53.8358 20.0717 55 17.6718 55 15C55 10.0294 50.9706 6 46 6ZM42 13C42 10.7909 43.7909 9 46 9C48.2091 9 50 10.7909 50 13C50 15.2091 48.2091 17 46 17C43.7909 17 42 15.2091 42 13Z'
          fill='white'
        />
        <path
          d='M43 21C42.7348 21 42.4804 21.1054 42.2929 21.2929C42.1054 21.4804 42 21.7348 42 22V23.0645C43.205 23.6633 44.5632 24 46 24C47.4368 24 48.795 23.6633 50 23.0645V22C50 21.7348 49.8946 21.4804 49.7071 21.2929C49.5196 21.1054 49.2652 21 49 21H43Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M37 15C37 10.0294 41.0294 6 46 6C50.9706 6 55 10.0294 55 15C55 17.6718 53.8358 20.0717 51.9869 21.72C51.922 21.0271 51.6175 20.3749 51.1213 19.8787C50.5587 19.3161 49.7957 19 49 19H43C42.2043 19 41.4413 19.3161 40.8787 19.8787C40.3825 20.3749 40.078 21.0271 40.0131 21.72C38.1642 20.0717 37 17.6718 37 15ZM42 23.0645C41.2772 22.7053 40.6095 22.2517 40.0131 21.72C40.0044 21.8127 40 21.9061 40 22V23.662C40 24.2143 40.4477 24.662 41 24.662C41.5523 24.662 42 24.2143 42 23.662V23.0645ZM42 23.0645V22C42 21.7348 42.1054 21.4804 42.2929 21.2929C42.4804 21.1054 42.7348 21 43 21H49C49.2652 21 49.5196 21.1054 49.7071 21.2929C49.8946 21.4804 50 21.7348 50 22V23.0645C48.795 23.6633 47.4368 24 46 24C44.5632 24 43.205 23.6633 42 23.0645ZM46 4C39.9249 4 35 8.92487 35 15C35 21.0751 39.9249 26 46 26C52.0751 26 57 21.0751 57 15C57 8.92487 52.0751 4 46 4Z'
          fill='#6E6E6E'
        />
        <path
          d='M41 24.662C41.5523 24.662 42 24.2143 42 23.662V23.0645C41.2772 22.7053 40.6095 22.2517 40.0131 21.72C40.0044 21.8127 40 21.9061 40 22V23.662C40 24.2143 40.4477 24.662 41 24.662Z'
          fill='#6E6E6E'
        />
      </g>
      <g filter='url(#filter1_dd_1336_27986)'>
        <rect
          x={96}
          y={15}
          width={84}
          height={94}
          rx={4}
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x={96.5}
          y={15.5}
          width={83}
          height={93}
          rx={3.5}
          stroke='url(#paint1_linear_1336_27986)'
          shapeRendering='crispEdges'
        />
        <g clipPath='url(#clip1_1336_27986)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M126 33.9166C126.23 33.9166 126.417 34.1032 126.417 34.3333V42.6666C126.417 42.8967 126.23 43.0833 126 43.0833C125.77 43.0833 125.583 42.8967 125.583 42.6666V34.3333C125.583 34.1032 125.77 33.9166 126 33.9166Z'
            fill='#6E6E6E'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M123.633 35.7158C123.984 35.3642 124.461 35.1666 124.958 35.1666H128.083C128.314 35.1666 128.5 35.3532 128.5 35.5833C128.5 35.8134 128.314 36 128.083 36H124.958C124.682 36 124.417 36.1097 124.222 36.3051C124.027 36.5004 123.917 36.7654 123.917 37.0416C123.917 37.3179 124.027 37.5828 124.222 37.7782C124.417 37.9735 124.682 38.0833 124.958 38.0833H127.042C127.539 38.0833 128.016 38.2808 128.368 38.6325C128.719 38.9841 128.917 39.461 128.917 39.9583C128.917 40.4556 128.719 40.9325 128.368 41.2841C128.016 41.6357 127.539 41.8333 127.042 41.8333H123.5C123.27 41.8333 123.083 41.6467 123.083 41.4166C123.083 41.1865 123.27 41 123.5 41H127.042C127.318 41 127.583 40.8902 127.778 40.6949C127.974 40.4995 128.083 40.2346 128.083 39.9583C128.083 39.682 127.974 39.4171 127.778 39.2217C127.583 39.0264 127.318 38.9166 127.042 38.9166H124.958C124.461 38.9166 123.984 38.7191 123.633 38.3675C123.281 38.0158 123.083 37.5389 123.083 37.0416C123.083 36.5443 123.281 36.0674 123.633 35.7158Z'
            fill='#6E6E6E'
          />
        </g>
        <path
          d='M134.026 42.0994C133.609 42.0994 133.234 42.0166 132.9 41.8509C132.566 41.6851 132.299 41.4579 132.097 41.169C131.896 40.8802 131.786 40.5511 131.767 40.1818H132.619C132.652 40.5109 132.802 40.7831 133.067 40.9986C133.334 41.2116 133.654 41.3182 134.026 41.3182C134.324 41.3182 134.589 41.2483 134.821 41.1087C135.055 40.969 135.239 40.7772 135.371 40.5334C135.506 40.2872 135.574 40.009 135.574 39.6989C135.574 39.3816 135.504 39.0987 135.364 38.8501C135.227 38.5992 135.038 38.4015 134.796 38.2571C134.555 38.1127 134.279 38.0393 133.969 38.0369C133.746 38.0346 133.518 38.0689 133.283 38.1399C133.049 38.2086 132.856 38.2973 132.705 38.4062L131.881 38.3068L132.321 34.7273H136.099V35.5085H133.06L132.804 37.6534H132.847C132.996 37.535 133.183 37.4368 133.408 37.3587C133.633 37.2805 133.867 37.2415 134.111 37.2415C134.556 37.2415 134.952 37.348 135.3 37.5611C135.651 37.7718 135.925 38.0606 136.124 38.4276C136.326 38.7945 136.426 39.2135 136.426 39.6847C136.426 40.1487 136.322 40.563 136.114 40.9276C135.908 41.2898 135.624 41.5762 135.261 41.7869C134.899 41.9953 134.487 42.0994 134.026 42.0994ZM140.609 42.0994C140.074 42.0994 139.618 41.9538 139.242 41.6626C138.865 41.3691 138.578 40.9441 138.379 40.3878C138.18 39.8291 138.081 39.1544 138.081 38.3636C138.081 37.5777 138.18 36.9065 138.379 36.3501C138.58 35.7914 138.869 35.3653 139.245 35.0717C139.624 34.7758 140.079 34.6278 140.609 34.6278C141.139 34.6278 141.593 34.7758 141.969 35.0717C142.348 35.3653 142.637 35.7914 142.836 36.3501C143.037 36.9065 143.137 37.5777 143.137 38.3636C143.137 39.1544 143.038 39.8291 142.839 40.3878C142.64 40.9441 142.353 41.3691 141.976 41.6626C141.6 41.9538 141.144 42.0994 140.609 42.0994ZM140.609 41.3182C141.139 41.3182 141.551 41.0625 141.845 40.5511C142.138 40.0398 142.285 39.3106 142.285 38.3636C142.285 37.7339 142.218 37.1977 142.083 36.755C141.95 36.3123 141.758 35.9749 141.507 35.7429C141.259 35.5109 140.959 35.3949 140.609 35.3949C140.083 35.3949 139.673 35.6541 139.377 36.1726C139.081 36.6887 138.933 37.419 138.933 38.3636C138.933 38.9934 138.999 39.5284 139.132 39.9688C139.264 40.4091 139.455 40.7441 139.703 40.9737C139.954 41.2034 140.256 41.3182 140.609 41.3182ZM147.259 42.0994C146.724 42.0994 146.268 41.9538 145.892 41.6626C145.515 41.3691 145.228 40.9441 145.029 40.3878C144.83 39.8291 144.731 39.1544 144.731 38.3636C144.731 37.5777 144.83 36.9065 145.029 36.3501C145.23 35.7914 145.519 35.3653 145.895 35.0717C146.274 34.7758 146.729 34.6278 147.259 34.6278C147.789 34.6278 148.243 34.7758 148.619 35.0717C148.998 35.3653 149.287 35.7914 149.486 36.3501C149.687 36.9065 149.787 37.5777 149.787 38.3636C149.787 39.1544 149.688 39.8291 149.489 40.3878C149.29 40.9441 149.003 41.3691 148.626 41.6626C148.25 41.9538 147.794 42.0994 147.259 42.0994ZM147.259 41.3182C147.789 41.3182 148.201 41.0625 148.495 40.5511C148.788 40.0398 148.935 39.3106 148.935 38.3636C148.935 37.7339 148.868 37.1977 148.733 36.755C148.6 36.3123 148.408 35.9749 148.157 35.7429C147.909 35.5109 147.609 35.3949 147.259 35.3949C146.733 35.3949 146.323 35.6541 146.027 36.1726C145.731 36.6887 145.583 37.419 145.583 38.3636C145.583 38.9934 145.649 39.5284 145.782 39.9688C145.914 40.4091 146.105 40.7441 146.353 40.9737C146.604 41.2034 146.906 41.3182 147.259 41.3182Z'
          fill='#6E6E6E'
        />
        <rect x={108} y={55} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={108} y={71} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={108} y={87} width={60} height={10} rx={2} fill='#E5E5E5' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M138 11C136.895 11 136 11.8954 136 13C136 14.1046 136.895 15 138 15C139.105 15 140 14.1046 140 13C140 11.8954 139.105 11 138 11ZM134 13C134 10.7909 135.791 9 138 9C140.209 9 142 10.7909 142 13C142 15.2091 140.209 17 138 17C135.791 17 134 15.2091 134 13Z'
          fill='#6E6E6E'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M138 6C133.029 6 129 10.0294 129 15C129 17.6718 130.164 20.0717 132.013 21.72C132.078 21.0271 132.382 20.3749 132.879 19.8787C133.441 19.3161 134.204 19 135 19H141C141.796 19 142.559 19.3161 143.121 19.8787C143.618 20.3749 143.922 21.0271 143.987 21.72C145.836 20.0717 147 17.6718 147 15C147 10.0294 142.971 6 138 6ZM134 13C134 10.7909 135.791 9 138 9C140.209 9 142 10.7909 142 13C142 15.2091 140.209 17 138 17C135.791 17 134 15.2091 134 13Z'
          fill='white'
        />
        <path
          d='M135 21C134.735 21 134.48 21.1054 134.293 21.2929C134.105 21.4804 134 21.7348 134 22V23.0645C135.205 23.6633 136.563 24 138 24C139.437 24 140.795 23.6633 142 23.0645V22C142 21.7348 141.895 21.4804 141.707 21.2929C141.52 21.1054 141.265 21 141 21H135Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M129 15C129 10.0294 133.029 6 138 6C142.971 6 147 10.0294 147 15C147 17.6718 145.836 20.0717 143.987 21.72C143.922 21.0271 143.618 20.3749 143.121 19.8787C142.559 19.3161 141.796 19 141 19H135C134.204 19 133.441 19.3161 132.879 19.8787C132.382 20.3749 132.078 21.0271 132.013 21.72C130.164 20.0717 129 17.6718 129 15ZM134 23.0645C133.277 22.7053 132.61 22.2517 132.013 21.72C132.004 21.8127 132 21.9061 132 22V23.662C132 24.2143 132.448 24.662 133 24.662C133.552 24.662 134 24.2143 134 23.662V23.0645ZM134 23.0645V22C134 21.7348 134.105 21.4804 134.293 21.2929C134.48 21.1054 134.735 21 135 21H141C141.265 21 141.52 21.1054 141.707 21.2929C141.895 21.4804 142 21.7348 142 22V23.0645C140.795 23.6633 139.437 24 138 24C136.563 24 135.205 23.6633 134 23.0645ZM138 4C131.925 4 127 8.92487 127 15C127 21.0751 131.925 26 138 26C144.075 26 149 21.0751 149 15C149 8.92487 144.075 4 138 4Z'
          fill='#6E6E6E'
        />
        <path
          d='M133 24.662C133.552 24.662 134 24.2143 134 23.662V23.0645C133.277 22.7053 132.61 22.2517 132.013 21.72C132.004 21.8127 132 21.9061 132 22V23.662C132 24.2143 132.448 24.662 133 24.662Z'
          fill='#6E6E6E'
        />
      </g>
      <g filter='url(#filter2_dd_1336_27986)'>
        <rect
          x={188}
          y={15}
          width={84}
          height={94}
          rx={4}
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x={188.5}
          y={15.5}
          width={83}
          height={93}
          rx={3.5}
          stroke='url(#paint2_linear_1336_27986)'
          shapeRendering='crispEdges'
        />
        <g clipPath='url(#clip2_1336_27986)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M218 33.9166C218.23 33.9166 218.417 34.1032 218.417 34.3333V42.6666C218.417 42.8967 218.23 43.0833 218 43.0833C217.77 43.0833 217.583 42.8967 217.583 42.6666V34.3333C217.583 34.1032 217.77 33.9166 218 33.9166Z'
            fill='#6E6E6E'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M215.633 35.7158C215.984 35.3642 216.461 35.1666 216.958 35.1666H220.083C220.314 35.1666 220.5 35.3532 220.5 35.5833C220.5 35.8134 220.314 36 220.083 36H216.958C216.682 36 216.417 36.1097 216.222 36.3051C216.027 36.5004 215.917 36.7654 215.917 37.0416C215.917 37.3179 216.027 37.5828 216.222 37.7782C216.417 37.9735 216.682 38.0833 216.958 38.0833H219.042C219.539 38.0833 220.016 38.2808 220.368 38.6325C220.719 38.9841 220.917 39.461 220.917 39.9583C220.917 40.4556 220.719 40.9325 220.368 41.2841C220.016 41.6357 219.539 41.8333 219.042 41.8333H215.5C215.27 41.8333 215.083 41.6467 215.083 41.4166C215.083 41.1865 215.27 41 215.5 41H219.042C219.318 41 219.583 40.8902 219.778 40.6949C219.974 40.4995 220.083 40.2346 220.083 39.9583C220.083 39.682 219.974 39.4171 219.778 39.2217C219.583 39.0264 219.318 38.9166 219.042 38.9166H216.958C216.461 38.9166 215.984 38.7191 215.633 38.3675C215.281 38.0158 215.083 37.5389 215.083 37.0416C215.083 36.5443 215.281 36.0674 215.633 35.7158Z'
            fill='#6E6E6E'
          />
        </g>
        <path
          d='M226.168 42.0994C225.869 42.0947 225.571 42.0379 225.273 41.929C224.974 41.8201 224.702 41.6366 224.456 41.3786C224.21 41.1181 224.012 40.7666 223.863 40.3239C223.714 39.8788 223.639 39.3201 223.639 38.6477C223.639 38.0038 223.7 37.4332 223.82 36.9361C223.941 36.4366 224.116 36.0163 224.346 35.6754C224.576 35.3321 224.853 35.0717 225.177 34.8942C225.504 34.7166 225.872 34.6278 226.281 34.6278C226.688 34.6278 227.051 34.7095 227.368 34.8729C227.688 35.0339 227.948 35.2588 228.149 35.5476C228.35 35.8364 228.481 36.169 228.54 36.5455H227.673C227.593 36.2187 227.437 35.9477 227.205 35.7322C226.973 35.5168 226.665 35.4091 226.281 35.4091C225.718 35.4091 225.274 35.6541 224.95 36.1442C224.628 36.6342 224.465 37.322 224.463 38.2074H224.52C224.652 38.0062 224.81 37.8345 224.992 37.6925C225.177 37.5481 225.38 37.4368 225.603 37.3587C225.826 37.2805 226.061 37.2415 226.31 37.2415C226.726 37.2415 227.107 37.3456 227.453 37.554C227.799 37.7599 228.076 38.0452 228.284 38.4098C228.492 38.772 228.597 39.1875 228.597 39.6562C228.597 40.1061 228.496 40.518 228.295 40.892C228.094 41.2637 227.811 41.5597 227.446 41.7798C227.084 41.9976 226.658 42.1042 226.168 42.0994ZM226.168 41.3182C226.466 41.3182 226.733 41.2436 226.97 41.0945C227.209 40.9453 227.397 40.7453 227.535 40.4943C227.674 40.2434 227.744 39.964 227.744 39.6562C227.744 39.3556 227.677 39.0821 227.542 38.8359C227.409 38.5874 227.226 38.3897 226.991 38.2429C226.759 38.0961 226.494 38.0227 226.196 38.0227C225.971 38.0227 225.762 38.0677 225.567 38.1577C225.373 38.2453 225.203 38.366 225.056 38.5199C224.912 38.6738 224.798 38.8501 224.715 39.049C224.632 39.2455 224.591 39.4527 224.591 39.6705C224.591 39.9593 224.658 40.2292 224.793 40.4801C224.931 40.7311 225.118 40.9335 225.354 41.0874C225.594 41.2412 225.865 41.3182 226.168 41.3182ZM232.765 42.0994C232.23 42.0994 231.774 41.9538 231.398 41.6626C231.022 41.3691 230.734 40.9441 230.535 40.3878C230.336 39.8291 230.237 39.1544 230.237 38.3636C230.237 37.5777 230.336 36.9065 230.535 36.3501C230.736 35.7914 231.025 35.3653 231.402 35.0717C231.78 34.7758 232.235 34.6278 232.765 34.6278C233.296 34.6278 233.749 34.7758 234.125 35.0717C234.504 35.3653 234.793 35.7914 234.992 36.3501C235.193 36.9065 235.294 37.5777 235.294 38.3636C235.294 39.1544 235.194 39.8291 234.995 40.3878C234.796 40.9441 234.509 41.3691 234.132 41.6626C233.756 41.9538 233.3 42.0994 232.765 42.0994ZM232.765 41.3182C233.296 41.3182 233.707 41.0625 234.001 40.5511C234.295 40.0398 234.441 39.3106 234.441 38.3636C234.441 37.7339 234.374 37.1977 234.239 36.755C234.106 36.3123 233.915 35.9749 233.664 35.7429C233.415 35.5109 233.116 35.3949 232.765 35.3949C232.24 35.3949 231.829 35.6541 231.533 36.1726C231.237 36.6887 231.089 37.419 231.089 38.3636C231.089 38.9934 231.155 39.5284 231.288 39.9688C231.421 40.4091 231.611 40.7441 231.86 40.9737C232.111 41.2034 232.412 41.3182 232.765 41.3182ZM239.415 42.0994C238.88 42.0994 238.424 41.9538 238.048 41.6626C237.672 41.3691 237.384 40.9441 237.185 40.3878C236.986 39.8291 236.887 39.1544 236.887 38.3636C236.887 37.5777 236.986 36.9065 237.185 36.3501C237.386 35.7914 237.675 35.3653 238.052 35.0717C238.43 34.7758 238.885 34.6278 239.415 34.6278C239.946 34.6278 240.399 34.7758 240.775 35.0717C241.154 35.3653 241.443 35.7914 241.642 36.3501C241.843 36.9065 241.944 37.5777 241.944 38.3636C241.944 39.1544 241.844 39.8291 241.645 40.3878C241.446 40.9441 241.159 41.3691 240.782 41.6626C240.406 41.9538 239.95 42.0994 239.415 42.0994ZM239.415 41.3182C239.946 41.3182 240.357 41.0625 240.651 40.5511C240.945 40.0398 241.091 39.3106 241.091 38.3636C241.091 37.7339 241.024 37.1977 240.889 36.755C240.756 36.3123 240.565 35.9749 240.314 35.7429C240.065 35.5109 239.766 35.3949 239.415 35.3949C238.89 35.3949 238.479 35.6541 238.183 36.1726C237.887 36.6887 237.739 37.419 237.739 38.3636C237.739 38.9934 237.805 39.5284 237.938 39.9688C238.071 40.4091 238.261 40.7441 238.51 40.9737C238.761 41.2034 239.062 41.3182 239.415 41.3182Z'
          fill='#6E6E6E'
        />
        <rect x={200} y={55} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={200} y={71} width={60} height={10} rx={2} fill='#E5E5E5' />
        <rect x={200} y={87} width={60} height={10} rx={2} fill='#E5E5E5' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M230 11C228.895 11 228 11.8954 228 13C228 14.1046 228.895 15 230 15C231.105 15 232 14.1046 232 13C232 11.8954 231.105 11 230 11ZM226 13C226 10.7909 227.791 9 230 9C232.209 9 234 10.7909 234 13C234 15.2091 232.209 17 230 17C227.791 17 226 15.2091 226 13Z'
          fill='#6E6E6E'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M230 6C225.029 6 221 10.0294 221 15C221 17.6718 222.164 20.0717 224.013 21.72C224.078 21.0271 224.382 20.3749 224.879 19.8787C225.441 19.3161 226.204 19 227 19H233C233.796 19 234.559 19.3161 235.121 19.8787C235.618 20.3749 235.922 21.0271 235.987 21.72C237.836 20.0717 239 17.6718 239 15C239 10.0294 234.971 6 230 6ZM226 13C226 10.7909 227.791 9 230 9C232.209 9 234 10.7909 234 13C234 15.2091 232.209 17 230 17C227.791 17 226 15.2091 226 13Z'
          fill='white'
        />
        <path
          d='M227 21C226.735 21 226.48 21.1054 226.293 21.2929C226.105 21.4804 226 21.7348 226 22V23.0645C227.205 23.6633 228.563 24 230 24C231.437 24 232.795 23.6633 234 23.0645V22C234 21.7348 233.895 21.4804 233.707 21.2929C233.52 21.1054 233.265 21 233 21H227Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M221 15C221 10.0294 225.029 6 230 6C234.971 6 239 10.0294 239 15C239 17.6718 237.836 20.0717 235.987 21.72C235.922 21.0271 235.618 20.3749 235.121 19.8787C234.559 19.3161 233.796 19 233 19H227C226.204 19 225.441 19.3161 224.879 19.8787C224.382 20.3749 224.078 21.0271 224.013 21.72C222.164 20.0717 221 17.6718 221 15ZM226 23.0645C225.277 22.7053 224.61 22.2517 224.013 21.72C224.004 21.8127 224 21.9061 224 22V23.662C224 24.2143 224.448 24.662 225 24.662C225.552 24.662 226 24.2143 226 23.662V23.0645ZM226 23.0645V22C226 21.7348 226.105 21.4804 226.293 21.2929C226.48 21.1054 226.735 21 227 21H233C233.265 21 233.52 21.1054 233.707 21.2929C233.895 21.4804 234 21.7348 234 22V23.0645C232.795 23.6633 231.437 24 230 24C228.563 24 227.205 23.6633 226 23.0645ZM230 4C223.925 4 219 8.92487 219 15C219 21.0751 223.925 26 230 26C236.075 26 241 21.0751 241 15C241 8.92487 236.075 4 230 4Z'
          fill='#6E6E6E'
        />
        <path
          d='M225 24.662C225.552 24.662 226 24.2143 226 23.662V23.0645C225.277 22.7053 224.61 22.2517 224.013 21.72C224.004 21.8127 224 21.9061 224 22V23.662C224 24.2143 224.448 24.662 225 24.662Z'
          fill='#6E6E6E'
        />
      </g>
      <defs>
        <filter
          id='filter0_dd_1336_27986'
          x={0}
          y={0}
          width={92}
          height={114}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1336_27986'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_1336_27986'
            result='effect2_dropShadow_1336_27986'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1336_27986'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_dd_1336_27986'
          x={92}
          y={0}
          width={92}
          height={114}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1336_27986'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_1336_27986'
            result='effect2_dropShadow_1336_27986'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1336_27986'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_dd_1336_27986'
          x={184}
          y={0}
          width={92}
          height={114}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1336_27986'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_1336_27986'
            result='effect2_dropShadow_1336_27986'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1336_27986'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1336_27986'
          x1={46}
          y1={15}
          x2={46}
          y2={109}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#919191' />
          <stop offset={1} stopColor='#E5E5E5' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1336_27986'
          x1={138}
          y1={15}
          x2={138}
          y2={109}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#919191' />
          <stop offset={1} stopColor='#E5E5E5' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1336_27986'
          x1={230}
          y1={15}
          x2={230}
          y2={109}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#919191' />
          <stop offset={1} stopColor='#E5E5E5' />
        </linearGradient>
        <clipPath id='clip0_1336_27986'>
          <rect
            width={10}
            height={10}
            fill='white'
            transform='translate(29 33.5)'
          />
        </clipPath>
        <clipPath id='clip1_1336_27986'>
          <rect
            width={10}
            height={10}
            fill='white'
            transform='translate(121 33.5)'
          />
        </clipPath>
        <clipPath id='clip2_1336_27986'>
          <rect
            width={10}
            height={10}
            fill='white'
            transform='translate(213 33.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
